
interface CountryData {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
}

export const countries: CountryData[] = [
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'US', name: 'United States', dialCode: '+1', flag: '🇺🇸' },
  { code: 'GB', name: 'United Kingdom', dialCode: '+44', flag: '🇬🇧' },
  { code: 'NZ', name: 'New Zealand', dialCode: '+64', flag: '🇳🇿' },
  { code: 'CA', name: 'Canada', dialCode: '+1', flag: '🇨🇦' },
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'SG', name: 'Singapore', dialCode: '+65', flag: '🇸🇬' }
];

export const formatPhoneNumber = (localNumber: string, countryCode: string): string => {
  const cleanNumber = localNumber.replace(/\D/g, '');
  return `${countryCode}${cleanNumber}`;
};

export const splitPhoneNumber = (fullNumber: string): { countryCode: string; localNumber: string } => {
  if (!fullNumber) return { countryCode: countries[0].dialCode, localNumber: '' };
  
  // If the number starts with +, try to match with a country code
  if (fullNumber.startsWith('+')) {
    const matchingCountry = countries.find(country => 
      fullNumber.startsWith(country.dialCode)
    );
    
    if (matchingCountry) {
      return {
        countryCode: matchingCountry.dialCode,
        localNumber: fullNumber.slice(matchingCountry.dialCode.length)
      };
    }
  }
  
  // Default to first country if no match found
  return { countryCode: countries[0].dialCode, localNumber: fullNumber };
};

export const detectUserCountry = (): CountryData => {
  try {
    // Try to get country from navigator language
    const language = navigator.language;
    const countryCode = language.split('-')[1]?.toUpperCase();
    
    if (countryCode) {
      const country = countries.find(c => c.code === countryCode);
      if (country) return country;
    }

    // Try to get country from Intl API
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeZoneCountry = timeZone.split('/')[0];
    const tzCountry = countries.find(c => c.name === timeZoneCountry);
    if (tzCountry) return tzCountry;

  } catch (error) {
    console.warn('Error detecting user country:', error);
  }

  // Default to Australia if detection fails
  return countries[0];
};
